import { DeleteOutlined, InboxOutlined, PaperClipOutlined } from "@ant-design/icons";
import { App, Button, List, Radio, Space, Upload } from "antd";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { deleteAttachment, listAttachments, uploadAttachment } from "../../api/attachmentApi";

export function AttachmentPanel({
  module = "DailyEntry",
  entityId,
  tempKey,
  compact = false
}: {
  module?: string;
  entityId?: string | number | null;
  tempKey?: string | null;
  compact?: boolean;
}) {
  const { message } = App.useApp();
  const [attachmentType, setAttachmentType] = useState<"bill" | "voucher">("bill");
  const canList = Boolean(entityId);
  const query = useQuery({
    queryKey: ["attachments", module, entityId],
    enabled: canList,
    queryFn: () => listAttachments(module, entityId!)
  });

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Radio.Group size="small" value={attachmentType} onChange={(e) => setAttachmentType(e.target.value)}>
        <Radio.Button value="bill">Bill</Radio.Button>
        <Radio.Button value="voucher">Voucher</Radio.Button>
      </Radio.Group>
      <Upload.Dragger
        multiple
        className="attachment-panel"
        showUploadList={!compact}
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            await uploadAttachment({ module, entityId, tempKey, attachmentType, file: file as File });
            message.success("Attachment uploaded");
            query.refetch();
            onSuccess?.("ok");
          } catch (err) {
            message.error("Unable to upload attachment");
            onError?.(err as Error);
          }
        }}
      >
        <p className="ant-upload-drag-icon"><InboxOutlined /></p>
        <p className="ant-upload-text">Drop vouchers, bills, PDFs, or spreadsheets here</p>
      </Upload.Dragger>
      {canList ? (
        <List
          size="small"
          loading={query.isLoading}
          dataSource={query.data ?? []}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button key="open" size="small" icon={<PaperClipOutlined />} href={item.downloadUrl} target="_blank" />,
                <Button key="delete" size="small" danger icon={<DeleteOutlined />} onClick={async () => {
                  await deleteAttachment(item.id);
                  query.refetch();
                }} />
              ]}
            >
              <List.Item.Meta title={item.fileName} description={item.attachmentType} />
            </List.Item>
          )}
        />
      ) : null}
    </Space>
  );
}
